/**
 * Вызов save на живом DocsAPI.DocEditor (form-save, не кнопка внутри iframe).
 * `true` только если команда реально ушла без throw.
 */

export type R7DocEditorForceSaveConnector = {
  executeMethod?: (method: string, data?: unknown, callback?: (result: unknown) => void) => void
}

export type R7DocEditorForceSaveInstance = {
  serviceCommand?: (command: string, data?: unknown) => void
  createConnector?: () => R7DocEditorForceSaveConnector | null | undefined
}

const LOG_PREFIX = '[R7 DocEditor]'

function collectFunctionNames(inst: object): string[] {
  const names = new Set<string>()
  const addFrom = (obj: object | null) => {
    if (!obj) return
    for (const key of Object.getOwnPropertyNames(obj)) {
      try {
        if (typeof (inst as Record<string, unknown>)[key] === 'function') names.add(key)
      } catch {
        /* getter */
      }
    }
  }
  addFrom(inst)
  addFrom(Object.getPrototypeOf(inst))
  return [...names].sort()
}

function tryExecuteMethod(
  connector: R7DocEditorForceSaveConnector,
  method: string,
): boolean {
  if (typeof connector.executeMethod !== 'function') return false
  connector.executeMethod(method, [])
  return true
}

/**
 * `serviceCommand("forcesave")`, иначе connector `Save` / `forcesave`.
 * Warn всегда: путь вызова или причина `false`.
 */
export function invokeR7DocEditorForceSave(
  inst: R7DocEditorForceSaveInstance | null | undefined,
): boolean {
  if (!inst) {
    console.warn(`${LOG_PREFIX} form-save skipped: no editor instance`)
    return false
  }
  const methods = collectFunctionNames(inst)

  if (typeof inst.serviceCommand === 'function') {
    try {
      inst.serviceCommand('forcesave', false)
      console.warn(`${LOG_PREFIX} form-save invoked via serviceCommand`, { methods })
      return true
    } catch (error) {
      console.warn(`${LOG_PREFIX} serviceCommand(forcesave) threw`, { methods, error })
    }
  }

  if (typeof inst.createConnector === 'function') {
    try {
      const connector = inst.createConnector()
      if (connector && tryExecuteMethod(connector, 'Save')) {
        console.warn(`${LOG_PREFIX} form-save invoked via createConnector executeMethod(Save)`, {
          methods,
        })
        return true
      }
      if (connector && tryExecuteMethod(connector, 'forcesave')) {
        console.warn(`${LOG_PREFIX} form-save invoked via createConnector executeMethod(forcesave)`, {
          methods,
        })
        return true
      }
    } catch (error) {
      console.warn(`${LOG_PREFIX} createConnector threw`, { methods, error })
    }
  }

  console.warn(`${LOG_PREFIX} form-save skipped: no serviceCommand/createConnector`, { methods })
  return false
}
